<div class="aboutus">
  <div class="container">
    <div class="row">
      <div class="col-md-4 join" style="margin-top: -8px;">
        <div>
          <div class="col-md-12">
            <a href="https://www.demo.hadeen-place.fr">
              <img width="auto" height="auto" loading="eager" class="img-fluid" src="assets/logo.png" alt="france-shopping" title="france-shopping" style="width: 200px;">
              <p class="my-2" style="text-align: center;font-weight: 300;font-size: 11px; text-decoration: none; color: var(--color-secondary);
                font-family: 'SFCompactDisplay-Regular';">
                Copyright {{currentYear}} &#169; www.demo.hadeen-place.fr
              </p>
            </a>
          </div>
          <div class="col-md-12 text-center" style="margin-top: 2.5%;">
            <a href="https://www.marketplacesolution.fr">
              <img width="auto" height="auto" loading="lazy" src="../../../../assets/logo_marketplacesolution.png" alt="marketplacesolution" title="marketplacesolution" class="mt-3" style="max-width: 125px; object-fit: contain; height: 40px;">
            </a>
          </div>
        </div>
      </div>

      <div class="col-6 col-md offset-md-1">
        <p class="footer-title mb-2" style="font-size: 15px; font-family: 'SFCOmpact Semibold';">ESPACE INFORMATIONS</p>
        <p class="my-1" *ngFor="let espace of espaces">
          <span (click)="goTo(espace)" style="cursor: pointer;font-size: 14px;">{{espace}}</span>
        </p>
      </div>

      <div class="col-6 col-md">
        <p class="footer-title mb-2" style="font-size: 15px; font-family: 'SFCOmpact Semibold';">NOUS CONNAÎTRE</p>
        <p class="my-1" *ngFor="let c of connaitres">
          <span (click)="goTo(c)" style="cursor: pointer;font-size: 14px;">{{c}}</span>
        </p>
      </div>
    </div>
  </div>
</div>

<!-- modal pour contacter le moderateur -->
<div class="modal fade" id="modalContactModerateur2" tabindex="-1" role="dialog" aria-labelledby="modalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content" style="border-radius: 8px;">

      <div class="modal-header pb-0">
        <div class="col-12">
          <p>À : France Shopping</p>
        </div>
      </div>
      <div class="modal-body">
        <div class="col-sm-12">
          <textarea class="form-control col-sm-12 area" rows="5" placeholder="Ecrire le message ici..."
            [(ngModel)]="messageText"></textarea>
          <button class="h-btn-grey-green float-right mt-2 px-3" data-dismiss="modal" mat-flat-button
            (click)="sendMessage()">Envoyer</button>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- end modal pour contacter le moderateur -->

<ng-template #loginTemplateFooter>
  <app-login [modal]="modalOpenService.modalRef2" [newsCustomer]="true"></app-login>
</ng-template>
